import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({ pageCount, onPageChange }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const updateScreenSize = () => setIsSmallScreen(window.innerWidth < 640);
    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  return (
    <div className="bg-transparent w-full sm:w-auto overflow-x-auto">
      <ReactPaginate
       previousLabel={"<"}
       nextLabel={">"}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={isSmallScreen ? 1 : 2}
        pageRangeDisplayed={isSmallScreen ? 1 : 3}
        onPageChange={onPageChange}
        containerClassName={"flex flex-wrap justify-center items-center gap-1.5 sm:gap-2 py-3 sm:py-4 text-foreground"}
        pageClassName={
          "min-w-[2.25rem] h-9 px-2 flex justify-center bg-card items-center border border-border hover:bg-secondary hover:text-primary rounded-xl text-sm font-bold text-foreground cursor-pointer pagination-link transition-all duration-300"
        }
        activeClassName="!bg-primary !text-white hover:!bg-accent hover:!text-white active-pagination-link !border-primary shadow-theme"
        breakClassName={
          "min-w-[2.25rem] h-9 px-2 flex justify-center items-center bg-card border border-border rounded-xl text-sm font-bold text-muted-foreground cursor-pointer pagination-link"
        }
        previousClassName={
          "min-w-[2.25rem] h-9 px-2 flex justify-center items-center bg-card border border-border rounded-xl text-sm font-bold text-foreground hover:bg-secondary hover:text-primary cursor-pointer pagination-link transition-all duration-300"
        }
        nextClassName={
          "min-w-[2.25rem] h-9 px-2 flex justify-center items-center bg-card border border-border rounded-xl text-sm font-bold text-foreground hover:bg-secondary hover:text-primary cursor-pointer pagination-link transition-all duration-300"
        }
        disabledClassName={"opacity-50 cursor-not-allowed"}
      />
    </div>
  );
};

export default Pagination;
